// extracted by mini-css-extract-plugin
export var aboutPreview = "preview-module--aboutPreview--hp8MC";
export var aboutPreview__content = "preview-module--aboutPreview__content--co6nQ";
export var aboutPreview__img = "preview-module--aboutPreview__img--r97YX";
export var aboutPreview__left = "preview-module--aboutPreview__left--hlL6B";
export var aboutPreview__right = "preview-module--aboutPreview__right--qZWjy";
export var aboutPreview__tag = "preview-module--aboutPreview__tag--hO9Ai";
export var aboutPreview__title = "preview-module--aboutPreview__title--QbU+f";
export var aboutPreview__year = "preview-module--aboutPreview__year--qJcWS";